function mlAddFiltersToForm(form, mlFilters) {
  // Filters container
  var mlFiltersContainer = $('<div class="list-filters__filters"/>');
  mlFiltersContainer.appendTo(form);

  $.each(mlFilters, function (index, mlFilter) {
    // Filter wrapper
    var filterWrapper = $('<div class="list-filter__wrapper"/>');
    filterWrapper.appendTo(mlFiltersContainer);

    // Filters
    $.each(mlFilter, function (index, item) {
      var filterContainer = $('<div class="list-filter__container"/>');
      filterContainer.attr('data-filter', item.filter);
      filterContainer.appendTo(filterWrapper);

      var filterRadioButton = $('<div class="list-filter__radio-button"/>');
      filterRadioButton.html(
        '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewbox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path><circle cx="12" cy="12" r="5"></circle></svg>'
      );
      filterRadioButton.appendTo(filterContainer);

      var filterLabel = $('<div class="list-filter__label"/>');
      filterLabel.html(item.label);
      filterLabel.appendTo(filterContainer);
    });
  });

  // Button
  var mlFiltersSubmitButton = $(
    '<button class="list-filter__button button button--small button--block"/>'
  );
  $(mlFiltersSubmitButton).attr('type', 'button');
  mlFiltersSubmitButton.on('click', function () {
    requestMediaLibraryData();
    closeFilters($('.list-filters__container'));
  });
  mlFiltersSubmitButton.html('Filter anwenden');
  mlFiltersSubmitButton.appendTo(form);
}

// Update categories

function initMediaLibraryCategories(categories) {
  var container = $('.list-filters__container--categories');
  if (!container.data('categoriesInitialized')) {
    var content = container.find('.list-filters__content');
    mlAddFiltersToForm(content, [categories]);
    container.find('.list-filter__wrapper').attr('data-multiple', '');
    initFilters();
    container.data('categoriesInitialized', true);
  }
}
